export default "__VITE_PUBLIC_ASSET__d385cf8d__"